<template>
    <div class="page-not-found">
        <h1 class="page-not-found-header">
            <span>oops</span> Error <span>Page not found</span>
        </h1>
        <p class="bg-light text-center w-50 mx-auto p-2 rounded-3">
            Please check the URL or navigate to one of the following:
        </p>
        <ul class="ms-3">
            Go to :
            <li>
                <h5
                    class="ms-2 p-1"
                    v-for="(link, index) in pageNotFoundLinks"
                    :key="index"
                >
                    <router-link class="page-not-found-links" :to="link.to">{{
                        link.name
                    }}</router-link>
                </h5>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: "PageNotFound",
    data() {
        return {
            pageNotFoundLinks: [{ name: "home", to: "/" }],
        };
    },
};
</script>
<style lang="scss">
.page-not-found {
    min-height: var(--min-height-page);
    background-image: url(@/assets/imgs/backgrounds/404-error.gif);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    margin-top: var(--app-header-height);
}
.page-not-found-header {
    width: 100%;
    text-align: center;
    color: orangered;
    & > span {
        color: rgb(109, 56, 39);
        font-size: 18pt;
    }
}
.page-not-found-links {
    text-decoration: none;
}
</style>
